"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLessCdnUrl = void 0;
var _manifest_css = _interopRequireDefault(require("../manifest_css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
lessSrcFile: file you want to create href for
cdnOrigin: make sure one of the valid CDN urls (static.concursolutions.com or static.concurcdn.cn) are passed based on where app is hosted
useCDN: pass value as false if you are running less:watcher on your local dev box
*/
var getLessCdnUrl = exports.getLessCdnUrl = function getLessCdnUrl(lessSrcFile) {
  var cdnOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var useCDN = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (useCDN || cdnOrigin.indexOf('//static') === 0) {
    var cssFile = _manifest_css["default"][lessSrcFile];
    return cssFile ? "".concat(cdnOrigin).concat(cssFile) : '';
  }
  return "".concat(cdnOrigin).concat(lessSrcFile);
};